<template>
  <div class="ParticularSucceed" >
    <DtList :orderId="orderId" @priceList="priceList"></DtList>
  </div>
</template>

<script>
import DtList from "../common/DtList";
export default {
  created() {
    this.orderId = localStorage.getItem("orderId");
  },
  data() {
    return {
      orderId: "",
      DTList:[]
    };
  },
  methods: {
    priceList(DTList) {
      this.DTList = DTList;
       this.$emit("priceList", DTList);
    }
  },
  components: {
    DtList
  }
};
</script>

<style scoped>
.ParticularSucceed {
  height: 100%;
}

</style>